import mNewTable from './Main';
export default mNewTable;
